
class FAQManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.faqs = []
    }
    run() {
        document.querySelectorAll('[data-faq]').forEach((el) => {
            const className = el.dataset.faq || 'faq__item--is-open'
            const faq = new FAQ(this, el, className)
            faq.run()
            this.faqs.push(faq)
        })
    }
    clear() {
        this.faqs.forEach(faq => {
            faq.close()
        })
    }
}

class FAQ {
    constructor(parent, el, className) {
        this.parent = parent
        this.el = el
        this.className = className
    }
    run() {
        this.questionEL = this.el.querySelector('[data-faq-question]')
        if (!this.questionEL) {
            return
        }

        this.questionEL.addEventListener('click', () => {
            this.onClick()
        })

        this.answerEL = this.el.querySelector('[data-faq-answer]')
        if (!this.answerEL) {
            return
        }

        this.setDefaultHeight(this.answerEL.getBoundingClientRect().height)
    }
    setDefaultHeight(height) {
        this.el.style.setProperty('--max-height', height + "px")
    }
    onClick() {
        this.parent.clear()
        this.toggle()
    }
    close() {
        this.el.classList.remove(this.className)
    }
    open() {
        this.el.classList.add(this.className)
    }
    toggle() {
        this.el.classList.toggle(this.className)
    }
}

export default FAQManager